<template>
  <span class="money-label">$ {{ valorFormateado }}</span>
</template>

<script>
import { formatMoney } from "@/utils";

export default {
  name: "MoneyLabel",
  props: ["valor"],
  computed: {
    valorFormateado() {
      return formatMoney(this.valor);
    }
  }
};
</script>

<style scoped>
.money-label {
  white-space: nowrap;
}
</style>
